export {default} from '../../../core/components/Repository/Popup';